import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import FailedIcon from 'icons/exclamation-circle.svg';
import ProgressIcon from 'icons/progress.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import DownloadModal from 'components/application/DownloadModal';

import { sendAnalytics } from 'components/helpers/analytics';

export default function DownloadModalWrapper({
  analyticProps,
  analyticTrackingId,
  closeModal,
  downloadAction,
  downloadStatus,
  isLandscape = true,
  modalIsOpen,
  resetAction,
  retryAction,
}) {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'application.DownloadModalWrapper',
  });

  const { t: i18nTCommon } = useTranslation('common');

  const downloadAndCloseModal = () => {
    downloadAction();
    closeModal();
    resetAction();
    sendAnalytics(analyticTrackingId, analyticProps);
  };

  const resetAndCloseModal = () => {
    closeModal();
    resetAction();
  };

  const handleActionButtonClick = () => {
    downloadStatus.downloadFailed ? retryAction() : downloadAndCloseModal();
  };

  const setIsButtonDisabledState = () => {
    downloadStatus.downloadInProgress ?
      setIsButtonDisabled(true)
    : setIsButtonDisabled(false);
  };

  useEffect(() => {
    downloadStatus && setIsButtonDisabledState();
  }, [downloadStatus]);

  return (
    <DownloadModal
      actionButton={
        <FilledButton
          color='mint'
          disabled={isButtonDisabled}
          onClick={handleActionButtonClick}
        >
          <ProgressIcon
            className={classNames(
              (
                downloadStatus.downloadSucceeded ||
                  downloadStatus.downloadFailed
              ) ?
                'hide'
              : 'tw-mr-1',
            )}
            height={18}
            width={18}
          />
          {downloadStatus.downloadSucceeded ?
            i18nTCommon('shared.downloadNow')
          : downloadStatus.downloadFailed ?
            i18nTCommon('shared.retry')
          : i18nTCommon('shared.pleaseWait...')}
        </FilledButton>
      }
      body={
        downloadStatus.downloadSucceeded ?
          i18nTCommon('attachments.pdfReadyToDownload')
        : downloadStatus.downloadFailed ?
          i18nTCommon('attachments.problemCreatingPdf')
        : i18nTCommon('shared.downloading...')
      }
      bodyIcon={
        downloadStatus.downloadFailed && (
          <FailedIcon className='icon--within-text' />
        )
      }
      header={i18nT('header')}
      isFailed={downloadStatus.downloadFailed}
      isLandscape={isLandscape}
      isOpen={modalIsOpen}
      onClose={resetAndCloseModal}
    />
  );
}

DownloadModalWrapper.propsTypes = {
  closeModal: PropTypes.func.isRequired,
  downloadAction: PropTypes.func.isRequired,
  downloadStatus: PropTypes.string.isRequired,
  isLandscape: PropTypes.bool,
  modalIsOpen: PropTypes.bool.isRequired,
  resetAction: PropTypes.func.isRequired,
  retryAction: PropTypes.func.isRequired,
};
